jQuery(".newsletter_submit_btn").on("click", function(e) {
  var t = jQuery(".footer-email").val();
  jQuery("#k_id_email").val(t);
  //var key = e.which;
  var check_email = validEmail(t);
  if(check_email==true){
    //jQuery(".footer-more-fields").addClass("is-active");
  	//jQuery("#overlay").addClass("is-active footer-form-overlay");
	jQuery("#email_signup_footer").submit()
    jQuery(".footer-signup .error_message").text("Please enter a valid email!").hide();
  }else{
    jQuery(".footer-signup .error_message").text("Please enter a valid email!").show();
  }
 
				
  });

jQuery(".close-footer-more").on("click", function() {
       jQuery("#email_signup_footer").submit()
 });

function validEmail(v) {
    var r = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
    return (v.match(r) == null) ? false : true;
}